export default __webpack_public_path__ + "static/media/fireplace.658ed382.mp3";